<template>
  <div class="card">
    <Toast />
    <div class="title">List Expense</div>

    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Tambah Biaya Akun"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="add_price_account_dialog = true"
        />
        <Button
          label="Buat Expense"
          icon="pi pi-plus"
          class="p-button-success"
          @click="create_expense_dialog = true"
        />
      </template>
    </Toolbar>

    <DataTable
      :value="items"
      :lazy="false"
      :paginator="true"
      :rows="10"
      :loading="loading.filter"
      @page="getExpense($event)"
    >
      <template #header>
        <div class="p-grid p-fluid p-mb-2">
          <AutoComplete
            class="p-col"
            placeholder="Account Price"
            :dropdown="true"
            :suggestions="account_price_filtered"
            @complete="setListAccountPrice($event)"
            field="name"
            optionLabel="name"
            v-model="filter.account"
          >
            <template #item="slotProps">
              <div class="p-col">
                <div>{{ slotProps.item.name }}</div>
              </div>
            </template>
          </AutoComplete>
          <div class="p-col">
            <Calendar
              v-model="filter.posting_date"
              :showIcon="true"
              dateFormat="yy-mm-dd"
              placeholder="Posting Date"
              :selectOtherMonths="true"
              :showButtonBar="false"
            />
          </div>
          <div class="p-col">
            <Button label="Cari" class="p-button-info" @click="getExpense()" />
          </div>
        </div>
      </template>
      <template #empty>Data tidak ada</template>
      <template #loading>Loading ...</template>
      <Column field="posting_date" header="Posting Date">
        <template #body="slotProps">
          {{ slotProps.data.posting_date }}
        </template>
      </Column>
      <Column field="account" header="Account">
        <template #body="slotProps">
          {{ slotProps.data.account }}
        </template>
      </Column>
      <Column field="price_name" header="Price Name">
        <template #body="slotProps">
          {{ slotProps.data.name }}
        </template>
      </Column>
      <Column field="amount" header="Amount">
        <template #body="slotProps">
          {{ slotProps.data.amount | currency }}
        </template>
      </Column>
      <Column field="description" header="Description">
        <template #body="slotProps">
          {{ slotProps.data.remarks }}
        </template>
      </Column>
      <Column>
        <template #body="slotProps">
          <Button
            type="button"
            icon="pi pi-pencil"
            style="margin-right: 0.5rem"
            class="p-button-rounded p-button-success"
            @click="showEditDialog(slotProps.data)"
          ></Button>
          <Button
            type="button"
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger"
            @click="confirmDelete(slotProps.data)"
          ></Button>
        </template>
      </Column>
    </DataTable>

    <!-- dialog buat akun biaya -->
    <Dialog
      :visible.sync="add_price_account_dialog"
      :style="{ width: '450px' }"
      header="Tambah Biaya Akun"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="">Nama Biaya</label>
        <InputText
          v-model="account_price.name"
          placeholder="Nama Biaya"
          @keyup.prevent="is_error.name = false"
        />
        <small class="p-error" v-if="is_error.name">{{ error_msg.name }}</small>
      </div>
      <div class="p-field">
        <label for="">Akun</label>
        <InputText
          v-model="account_price.account"
          placeholder="Akun"
          @keyup.prevent="is_error.account = false"
        />
        <small class="p-error" v-if="is_error.account">{{
          error_msg.account
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          class="p-button-outlined"
          @click="add_price_account_dialog = false"
        />
        <button
          label="Tambah"
          class="btn btn-primary"
          @click="addPriceAccount()"
        >
          Tambah
          <span v-if="loading.account">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
        </button>
      </template>
    </Dialog>

    <!-- dialog buat expense -->
    <Dialog
      :visible.sync="create_expense_dialog"
      :style="{ width: '500px' }"
      header="Buat Expense"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="">Posting Date</label>
        <Calendar
          v-model="create_expense.posting_date"
          :showIcon="true"
          dateFormat="yy-mm-dd"
          placeholder="Tanggal"
          :selectOtherMonths="true"
          :showButtonBar="true"
        />
        <small class="p-error" v-if="is_error.posting_date">{{
          error_msg.posting_date
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Biaya Akun</label>
        <AutoComplete
          class="p-col"
          placeholder="Account Price"
          :dropdown="true"
          :suggestions="account_price_filtered"
          @complete="setListAccountPrice($event)"
          field="name"
          optionLabel="name"
          v-model="create_expense.expense_account_id"
        >
          <template #item="slotProps">
            <div class="p-col">
              <div>{{ slotProps.item.name }}</div>
            </div>
          </template>
        </AutoComplete>
        <small class="p-error" v-if="is_error.expense_account_id">{{
          error_msg.expense_account_id
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Amount</label>
        <InputNumber
          v-model="create_expense.amount"
          :placeholder="'Amount'"
          mode="decimal"
          :min="0"
          @keyup.prevent="is_error.amount = false"
        />
        <small class="p-error" v-if="is_error.amount">{{
          error_msg.amount
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Description</label>
        <Textarea
          v-model="create_expense.remarks"
          placeholder="Description"
          rows="5"
          cols="30"
          @keyup.prevent="is_error.remarks = false"
        />
        <small class="p-error" v-if="is_error.remarks">{{
          error_msg.remarks
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          class="p-button-outlined"
          @click="create_expense_dialog = false"
        />
        <button label="Buat" class="btn btn-primary" @click="createExpense()">
          Buat
          <span v-if="loading.expense">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
        </button>
      </template>
    </Dialog>

    <!-- edit buat expense -->
    <Dialog
      :visible.sync="edit_expense_dialog"
      :style="{ width: '500px' }"
      header="Buat Expense"
      :modal="true"
      class="p-fluid"
      @complete="setListAccountPrice($event)"
    >
      <div class="p-field">
        <label for="">Posting Date</label>
        <Calendar
          v-model="create_expense.posting_date"
          :showIcon="true"
          dateFormat="yy-mm-dd"
          placeholder="Tanggal"
          :selectOtherMonths="true"
          :showButtonBar="true"
        />
        <small class="p-error" v-if="is_error.posting_date">{{
          error_msg.posting_date
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Biaya Akun</label>
        <AutoComplete
          class="p-col"
          placeholder="Account Price"
          :dropdown="true"
          :suggestions="account_price_filtered"
          @complete="setListAccountPrice($event)"
          field="name"
          optionLabel="name"
          v-model="create_expense.expense_account_id"
        >
          <template #item="slotProps">
            <div class="p-col">
              <div>{{ slotProps.item.name }}</div>
            </div>
          </template>
        </AutoComplete>
        <small class="p-error" v-if="is_error.expense_account_id">{{
          error_msg.expense_account_id
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Amount</label>
        <InputNumber
          v-model="create_expense.amount"
          :placeholder="'Amount'"
          mode="decimal"
          :min="0"
          @keyup.prevent="is_error.amount = false"
        />
        <small class="p-error" v-if="is_error.amount">{{
          error_msg.amount
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Description</label>
        <Textarea
          v-model="create_expense.remarks"
          placeholder="Description"
          rows="5"
          cols="30"
          @keyup.prevent="is_error.remarks = false"
        />
        <small class="p-error" v-if="is_error.remarks">{{
          error_msg.remarks
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          class="p-button-outlined"
          @click="edit_expense_dialog = false"
        />
        <button label="Buat" class="btn btn-primary" @click="putExpense()">
          Buat
          <span v-if="loading.expense">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
        </button>
      </template>
    </Dialog>

    <!-- dialog delete expense -->
    <Dialog
      :visible.sync="deleteDialog"
      :style="{ width: '450px' }"
      header="Confirm"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="create_expense">
          Apakah kamu yakin ingin menghapus
          <b>{{ create_expense.id }}</b
          >?
        </span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteDialog = false"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteExpense(create_expense.id)"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
let moment = require('moment')

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  watch: {
    user() {
      this.getAuthUser()
    }
  },
  data() {
    return {
      moment: moment,
      today: new Date().toISOString().split('T')[0],
      loading: {
        filter: true,
        account: false,
        expense: false
      },

      filter: {
        account: null,
        posting_date: null
      },

      add_price_account_dialog: false,
      create_expense_dialog: false,
      edit_expense_dialog: false,

      deleteDialog: false,

      items: null,
      account_prices: null,
      account_price_filtered: null,

      create_expense: {
        posting_date: '',
        expense_account_id: null,
        amount: '',
        remarks: ''
      },

      account_price: {
        name: '',
        account: ''
      },

      is_error: {
        posting_date: false,
        expense_account_id: false,
        amount: false,
        remarks: false,
        name: false,
        account: false
      },
      error_msg: {
        posting_date: '',
        expense_account_id: '',
        amount: '',
        remarks: '',
        name: '',
        account: ''
      }
    }
  },
  mounted() {
    this.getAuthUser()
    this.getExpense()
    this.getListAccountPrice()
  },
  methods: {
    getAuthUser() {
      this.create_expense.posting_date = this.today
    },

    getExpense() {
      // get filter.account
      let account = ''
      if (this.filter.account && this.filter.account.account) {
        account = this.filter.account.account
      }
      let posting_date = this.filter.posting_date
        ? moment(this.filter.posting_date).format('YYYY-MM-DD')
        : ''
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/list/expense?account=${account}&posting_date=${posting_date}`
        )
        .then(response => {
          this.loading.filter = false
          if (response.status === 200) {
            this.items = response.data.data.expense
          } else {
            console.error('gagal get')
          }
        })
    },

    async getListAccountPrice() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/list/expense-account`
        )

        if (response.status === 200) {
          this.account_prices = response.data.data.expense_account
        } else {
          console.error('Gagal mendapatkan data akun harga')
        }
      } catch (error) {
        console.error(
          'Terjadi kesalahan saat mengambil data akun harga:',
          error
        )
      }
    },

    setListAccountPrice(event) {
      this.getListAccountPrice()
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.account_price_filtered = [...this.account_prices]
        } else {
          this.account_price_filtered = this.account_prices.filter(item => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },

    addPriceAccount() {
      if (this.account_price.account == '') {
        this.error_msg.account = 'Akun harus diisi'
        this.is_error.account = true
      }

      if (this.account_price.name == '') {
        this.error_msg.name = 'Nama Biaya harus diisi'
        this.is_error.name = true
      }

      this.loading.account = true
      if (!this.is_error.name && !this.is_error.account) {
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/post/expense-account`,
            this.account_price
          )
          .then(response => {
            this.loading.account = false
            if (response.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Biaya akun berhasil dibuat',
                life: 3000
              })
              this.getExpense()
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Biaya akun gagal dibuat',
                life: 3000
              })
            }
            this.resetCreateData()
            this.add_price_account_dialog = false
          })
      }
    },

    createExpense() {
      if (this.create_expense.posting_date == null) {
        this.error_msg.posting_date = 'Tanggal harus diisi'
        this.is_error.posting_date = true
      } else {
        this.create_expense.posting_date = moment(
          this.create_expense.posting_date
        ).format('YYYY-MM-DD')
      }

      if (this.create_expense.expense_account_id == null) {
        this.error_msg.expense_account_id = 'Akun harus diisi'
        this.is_error.expense_account_id = true
      } else {
        this.create_expense.expense_account_id =
          this.create_expense.expense_account_id.id
      }

      if (this.create_expense.amount == '') {
        this.error_msg.amount = 'amount harus diisi'
        this.is_error.amount = true
      }

      if (this.create_expense.remarks == '') {
        this.error_msg.remarks = 'Deskripsi harus diisi'
        this.is_error.remarks = true
      }

      this.loading.expense = true
      if (
        !this.is_error.posting_date &&
        !this.is_error.account_price &&
        !this.is_error.amount &&
        !this.is_error.remarks
      ) {
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/post/expense`,
            this.create_expense
          )
          .then(response => {
            this.loading.expense = false
            if (response.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Expense berhasil dibuat',
                life: 3000
              })
              this.getExpense()
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Expense gagal dibuat',
                life: 3000
              })
            }
            this.resetCreateData()
            this.create_expense_dialog = false
          })
      }
    },

    resetCreateData() {
      this.account_price = {
        name: '',
        account: ''
      }
      this.create_expense = {
        posting_date: this.today,
        expense_account_id: null,
        amount: '',
        remarks: ''
      }
      this.is_error = {
        name: false,
        account: false,
        posting_date: false,
        expense_account_id: false,
        amount: false,
        remarks: false
      }
      this.error_msg = {
        name: '',
        account: '',
        posting_date: '',
        expense_account_id: '',
        amount: '',
        remarks: ''
      }
    },

    showEditDialog(data) {
      this.create_expense = data
      // get account price
      this.account_price_filtered = [...this.account_prices]
      this.account_price_filtered.forEach(item => {
        if (item.id === data.acc_id_expense) {
          this.create_expense.expense_account_id = item
        }
      })

      this.edit_expense_dialog = true
    },

    putExpense() {
      if (this.create_expense.posting_date == null) {
        this.error_msg.posting_date = 'Tanggal harus diisi'
        this.is_error.posting_date = true
      } else {
        this.create_expense.posting_date = moment(
          this.create_expense.posting_date
        ).format('YYYY-MM-DD')
      }

      if (this.create_expense.expense_account_id == null) {
        this.error_msg.expense_account_id = 'Akun harus diisi'
        this.is_error.expense_account_id = true
      } else {
        this.create_expense.expense_account_id =
          this.create_expense.expense_account_id.id
      }

      if (this.create_expense.amount == '') {
        this.error_msg.amount = 'amount harus diisi'
        this.is_error.amount = true
      }

      if (this.create_expense.remarks == '') {
        this.error_msg.remarks = 'Deskripsi harus diisi'
        this.is_error.remarks = true
      }

      this.loading.expense = true
      if (
        !this.is_error.posting_date &&
        !this.is_error.account_price &&
        !this.is_error.amount &&
        !this.is_error.remarks
      ) {
        this.$http
          .put(
            `${process.env.VUE_APP_API_URL}/dashboard/edit/expense/${this.create_expense.id}`,
            this.create_expense
          )
          .then(response => {
            this.loading.expense = false
            if (response.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Expense berhasil di update',
                life: 3000
              })
              this.getExpense()
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Expense gagal di update',
                life: 3000
              })
            }
            this.resetCreateData()
            this.edit_expense_dialog = false
          })
      }
    },

    confirmDelete(data) {
      this.create_expense = data
      this.deleteDialog = true
    },

    deleteExpense(id) {
      this.$http
        .delete(`${process.env.VUE_APP_API_URL}/dashboard/delete/expense/${id}`)
        .then(response => {
          this.deleteDialog = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Delete Success',
              detail: 'Data Deleted',
              life: 3000
            })
            this.getExpense()
          } else if (response.status === 403) {
            this.$toast.add({
              severity: 'error',
              summary: 'Delete Not Permitted',
              detail: `Data Can't be Deleted`,
              life: 3000
            })
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Delete Failed',
              detail: 'Data failed to Deleted',
              life: 3000
            })
            console.error('gagal delete')
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
